
import { initializeApp } from "firebase/app";
import { getAuth,GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyD1537J_qOQCLsxT5oJKx9HYXvDrS0k9fY",
  authDomain: "checklist-fef54.firebaseapp.com",
  projectId: "checklist-fef54",
  storageBucket: "checklist-fef54.firebasestorage.app",
  messagingSenderId: "557990214836",
  appId: "1:557990214836:web:28ff96d0266a9064816be1"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth=getAuth(app)
export const db = getFirestore(app);
const provider = new GoogleAuthProvider()
export {auth,provider}